import React, { useState, useEffect } from "react";
import '../css/sosmed.css';
import data from '../data/effort.json';
import hut from '../data/hut.json';

export default function Sosmed() {
    const [jsonData, setJsonData] = useState([]);
    const [jsonHut, setJsonHut] = useState([]);
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 425);

    useEffect(() => {
        setJsonData(data);
        setJsonHut(hut);
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 450);
        };
        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    return (
        <section className="sosmed">
            <h1 className="title">Sosial Media</h1>
            <div className="grid">
                {jsonData.map((item, index) => (
                    <a key={index}>
                        <div className="konten-sosmed">
                            <img src={item.img} className="g-ef"></img>
                            <p className="effort">{item.detail}
                                <span>
                                    <a href="#" className="sp">
                                        Lihat selengkapnya
                                    </a>
                                </span>
                            </p>
                            <div className="d-flex align-items-center gap-2">
                                <img src="../../assets/sosmed/whatsapp.svg" className="WA"></img>
                                <p className="ig">SMA LABORATORIUM UM OFFICIAL</p>
                            </div>
                        </div>
                    </a>
                ))}
            </div>
            <div className="sosmed-akhir d-lg-flex d-md-flex justify-content-between">
                <div className="bungkus-bakti">
                    <img src="../../assets/sosmed/sosmed3.svg" className="bakti"></img>
                    <h1 className="purna">Purnawiyata Bakti ke 24 SMA Lab UM</h1>
                    <div className="d-flex align-items-center gap-2">
                        <img src="../../assets/sosmed/youtube.svg" className="logo-sosmed"></img>
                        <p className="ig">SMA LAB UM</p>
                    </div>
                </div>
                <div className="senior">
                    <img src="../../assets/sosmed/sosmed4.svg" className="vid"></img>
                    <p className="guru">
                        Guru senior di sekolah kami nih... Pengen kenal lebih dekat? Yukk gabung bersama kami. only di SMA LAB UM Malang Info...
                        <span>
                            <a href="#" className="next-guru">
                                Lihat selengkapnya
                            </a>
                        </span>
                    </p>
                    <div className="d-flex align-items-center gap-2">
                        <img src="../../assets/sosmed/facebook.svg" className="logo-sosmed"></img>
                        <p className="ig" style={{ color: "#0066FF", fontWeight: "600" }}>Smalab UM</p>
                    </div>
                </div>
            </div>
            <button className="lihat btn cursor-pointer d-flex align-items-center gap-2 h-auto w-auto">
                <p className="lihat my-auto">Lihat Semua</p>
                <img src="../../assets/kabar/arrow-right2.svg"></img>
            </button>
        </section>
    )
}
